<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput
              label="Αριθμός υπόθεσης"
              type="number"
              v-model="case_number"
              horizontal
              class="fullInputHeight"
              :prepend="case_code_prefix"
              addLabelClasses="requiredLabel"
              :lazy="false"
              :disabled="true"
              @change="(val) => case_number = pad(case_number, 5)">
              <template #append>
                <multiselect 
                  placeholder="Τύπος επιθεώρησης"
                  v-model="inspection_type" 
                  trackBy="value"
                  label="label"
                  :options="inspection_types">
                </multiselect>
              </template>
            </CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Ημέρες επίσκεψης
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="days" 
                  id="days" 
                  @input="addDays"
                  :options="daysOptions"
                  placeholder="Ημέρες">
                </multiselect>
              </CCol>
            </div>
            <CInput
              v-for="(item, index) in next_visit"
              :key="index"
              :label="'Επόμενη επίσκεψη (' + (index + 1) +  ')'"
              type="date"
              v-model="next_visit[index]"
              horizontal
              addLabelClasses="requiredLabel"
            />
            <CInput horizontal type="text" label="Τοποθεσία" id="location" placeholder="Τοποθεσία" v-model="location"></CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Κατάσταση
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="status" 
                  id="status" 
                  :options="statusOptions"
                  label="label"
                  @input="updateStatus"
                  track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group" v-if="showClient">
              <CCol sm="3" class="requiredLabel">
                Πελάτης
              </CCol>
              <CCol sm="9">
                <multiselect 
                v-model="client" 
                id="client" 
                :options="clientOptions"
                label="label" 
                placeholder="Επέλεξε πελάτη που έχει υπογράψει σύμβαση"
                @input="refreshCategory()"
                track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Πρότυπο
              </CCol>
              <CCol sm="9">
                <multiselect 
                v-model="service" 
                id="service" 
                :options="servicesOptions"
                :disabled="!client"
                label="label" 
                @input="refreshSubcategory()"
                track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                ΕΑ/NACE
              </CCol>
              <CCol sm="9">
                <multiselect 
                v-model="service_subcategory" 
                id="service_subcategory" 
                :options="serviceSubcategoryOptions"
                label="label"
                multiple
                :disabled="subDisabled"
                track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Τιμολόγιο
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="bill_status" 
                  id="bill_status" 
                  :options="billStatusesOptions"
                  label="label"
                  track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
                <CCol sm="12">
                  Επιθεωρητές
                </CCol>
                <CCol sm="12">
                  <div class="d-flex">
                    <CButton color="primary" @click="refreshInspectors()" :disabled="service_subcategory.length <= 0">Ανανέωση Επιθεωρητών</CButton>
                    <div v-if="inspectorMessage" class="tt2">{{ inspectorMessage }}</div>
                  </div>
                 
                </CCol>
                <CCol sm="12" class="pt-2">
                  <template v-for="(item, index) in inspectors">
                    <CRow :key="`row-${item.id}`" class="pb-2">
                      <CCol sm="3" :key="`inspector-${item.id}`">
                        <label class="requiredLabel">Επιθεωρητής</label>
                        <multiselect 
                          v-model="item.inspector" 
                          :options="inspectorOptions"
                          label="label"
                          :show-labels="false"
                          track-by="value">
                        </multiselect>
                        <CBadge color="danger" class="inspectorBadge" v-show="item.inspector && item.inspector.dates.includes(item.date)">
                            Ο/Η επιθεωρητής έχει ανατεθεί σε άλλη υπόθεση κατά την επιλεγμένη ημερομηνία.
                        </CBadge>
                      </CCol>
                      <CCol sm="3" :key="`role-${item.id}`">
                        <label class="requiredLabel">Ρόλος</label>
                        <multiselect 
                          v-model="item.role"
                          :options="roles"
                          label="label"
                          :show-labels="false"
                          track-by="value">
                        </multiselect>
                      </CCol>
                      <CCol sm="2" :key="`price-${item.id}`">
                        <label class="requiredLabel">Τιμή</label>
                        <multiselect 
                          v-model="item.price"
                          :options="priceOptions"
                          label="label"
                          :show-labels="false"
                          :taggable="true"
                          @tag="(newTag) => addTag(newTag, index)"
                          track-by="value">
                        </multiselect>
                      </CCol>
                      <CCol sm="2" :key="`date-${item.id}`">
                        <label class="requiredLabel">Ημερομηνία</label>
                        <multiselect 
                          v-model="item.date" 
                          :options="next_visit">
                        </multiselect>
                      </CCol>
                      <CCol sm="2">
                        <label>Πληρώθηκε</label><br>
                        <CSwitch :checked.sync="item.paid" shape="pill" color="success" class="v-middle"/>
                      </CCol>
                    </CRow>
                  </template>
                </CCol>
                <CCol sm="12">
                  <CButton v-show="showAdd" color="primary" @click="addRow()">Προσθήκη</CButton>
                </CCol>
            </div>
            <CInput
                label="Επανάληψη σε"
                append="μήνες"
                horizontal
                v-show="showMonths"
                v-model="revision_months"
              />
              <CInput
                label="Αριθμός επόμενης υπόθεσης"
                type="number"
                v-model="next_case_number"
                horizontal
                :prepend="case_code_prefix"
                v-show="showMonths && revision_months > 0"
                :lazy="false"
                @change="(val) => next_case_number = pad(next_case_number, 5)"
              />
          </CForm>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader>
          <strong>Σύμβουλος - Υπεργολάβος</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <div class="form-row form-group">
              <CCol>
                <label>Σύμβουλος/Πωλητής</label>
                <multiselect 
                  v-model="consultant" 
                  :options="consultantOptions"
                  label="name"
                  :show-labels="false"
                  track-by="id">
                </multiselect>
              </CCol>
              <CCol>
                <CInput
                  label="Ποσό"
                  type="number"
                  v-model="consultant_price"
                />
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol>
                <label>Υπεργολάβος</label>
                <multiselect 
                  v-model="subcontractor"
                  :options="subcontractorOptions"
                  label="name"
                  :show-labels="false"
                  track-by="id">
                </multiselect>
              </CCol>
              <CCol>
                <CInput
                  label="Ποσό"
                  type="number"
                  v-model="subcontractor_price"
                />
              </CCol>
            </div>
            <CButton color="primary" @click="store()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { DatePicker } from 'v-calendar'
import MaskedInput from 'vue-text-mask'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
export default {
  name: 'CreateCase',
  props: ['services'],
  components: {
    'v-date-picker': DatePicker,
    MaskedInput,
    Multiselect,
  },
  props: {
    caption: {
      type: String,
      default: 'Create Cases'
    },
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  data: () => {
    return {
        statusOptions: [],
        next_visit: [''],
        days: 1,
        daysOptions: [ ...Array(30).keys() ].map( i => i+1),
        location: '',
        status: '',
        showMessage: false,
        message: '',
        dismissSecs: 7,
        client: '',
        showClient: true,
        servicesOptions: [],
        showAdd: true,
        billStatusesOptions: [],
        bill_status: '',
        showMonths: false,
        revision_months: 0,
        subDisabled: true,
        alertIsShown: false,
        service: '',
        roles: [],
        inspectorOptions: [],
        consultantOptions: [],
        subcontractorOptions: [],
        case_code_prefix: '0000.',
        case_number: '',
        next_case_number: '',
        subcontractor: null,
        consultant: null,
        subcontractor_price: null,
        consultant_price: null,
        inspection_types: [],
        inspection_type: '',
        inspectorMessage: '',
        priceOptions: [
          {
            label: 0,
            value: 0
          },
          {
            label: 25,
            value: 25
          },
          {
            label: 150,
            value: 150
          },
          {
            label: 200,
            value: 200
          },
        ],
        inspectors: [{id: 0, inspector: '', role: '', price: '', paid: false, date: ''}],
        clientOptions: [],
        serviceSubcategoryOptions: [],
        service_subcategory: '',
        dismissCountDown: 0,
        showDismissibleAlert: false,
        masks: {
          input: 'YYYY-MM-DD',
          data: ['YYYY-MM-DD']
        },
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/clients'})
    },
    updateStatus(event) {
      if (this.status && this.status.label == "Ολοκληρωμένη") {
        this.showMonths = true;
      } else {
        this.showMonths = false;
      }

      //ακυρώθηκε
      if (this.status && this.status.value == 4) {
        this.inspectors = [{id: 0, inspector: '', role: '', price: '', paid: false, date: ''}];
      }
    },
    store() {
        let self = this;

        let subcategories = [];
        if (self.service_subcategory) {
          subcategories = self.service_subcategory.map((item) => {return item.value;});
        }
        let inspectors = self.inspectors.filter((item) => item.inspector || item.role || item.price || item.date);
        inspectors = inspectors.map((item) => {
          let newItem = {};
          if (item.inspector) newItem.id = item.inspector.value;
          if (item.role) newItem.role = item.role.value;
          if (item.price) newItem.price = item.price.value;
          if (item.date) newItem.date = item.date;
          newItem.paid = item.paid;

          return newItem;
        });

        let service = null;
        if (self.service) {
          service = self.service.value;
        }

        let status = null;
        if (this.status) {
          status = this.status.value;
        }

        let bill_status = null;
        if (this.bill_status) {
          bill_status = this.bill_status.value;
        }
        axios.post('/api/cases?token=' + localStorage.getItem("api_token"),
        {
            next_visit: self.next_visit,
            location: self.location,
            status: status,
            client_id: self.client ? self.client.value : null,
            service_id: service,
            service_subcategories: subcategories,
            inspectors: inspectors,
            revision_months: self.revision_months,
            bill_status: bill_status,
            case_code: self.case_code_prefix + self.case_number,
            next_case_code: self.case_code_prefix + self.next_case_number,
            subcontractor_id: self.subcontractor ? self.subcontractor.id : null,
            consultant_id: self.consultant ? self.consultant.id : null,
            subcontractor_price: self.subcontractor_price,
            consultant_price: self.consultant_price,
            inspection_type: self.inspection_type ? self.inspection_type.value : null
        })
        .then(function (response) {
            self.$emit('added-case', self.$vnode.key);

            self.message = 'Επιτυχής καταχώρηση υπόθεσης.';
            self.showAlert();

            axios.post('/api/notifications?token=' + localStorage.getItem("api_token"),
            {
              notification_type: 'cases',
              notification_element_id: response.data.case_id,
              notification_message: 'Καταχωρήθηκε μία νέα υπόθεση'
            })
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    refreshInspectors() {
      let self = this;

      if (self.service && self.service_subcategory) {
        let subcategories = self.service_subcategory.map((item) => {
          return item.value;
        });
        axios.get('/api/inspectors/get_filtered_inspectors?token=' + localStorage.getItem("api_token"),{
          params: {
            service_id: self.service.value,
            subcategories: subcategories,
          }
        })
        .then(function (response) {
          self.inspectorMessage = ''
          self.inspectorOptions = response.data.inspectors.map((item) => {
            return {
              value: item.id,
              label: item.name,
              dates: item.cases.map((item) => item.pivot.date)
            }
          });
          if(self.inspectorOptions.length <= 0){
            self.inspectorMessage = 'Δεν βρέθηκαν Επιθεωτητές'
          }
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              self.$router.push({ path: '/login' }); 
            }
        });
      }
    },
    pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    },
    refreshSubcategory() {
      let self = this;
      if (self.service && self.service.code) {
        self.subDisabled = true;
        self.case_code_prefix = self.service.code + '.';
        self.case_number = self.pad(self.service.case_count + 1, 5);
        if (self.service) {
          axios.get('/api/services/get_subcategories/' + self.service.value + '?token=' + localStorage.getItem("api_token"))
          .then(function (response) {
            self.serviceSubcategoryOptions = response.data.service_subcategories.map((item) => {
              return {
                value: item.id,
                label: item.name
              }
            });
            self.service_subcategory = [];
            self.subDisabled = false;
            //self.refreshInspectors();
          }).catch(function (error) {
            console.log(error);
            self.$router.push({ path: '/login' });
          });
        }
      }
    },
    addRow () {
      let self = this;
      var id = Math.max.apply(Math,self.inspectors.map(function(o){return o.id;})) + 1;
      self.showAdd = true;
      self.inspectors.push({ id, inspector: '', role: '', price: '', paid: false, date: ''});
      if (self.inspectors.length >= 25) {
        self.showAdd = false;
      }
    },
    addTag (newTag, index) {
      const tag = {
        label: newTag,
        value: newTag
      }
      this.priceOptions.push(tag)
      this.inspectors[index].price = tag;
    },
    addDays() {
      console.log(this.days)
      if (this.days < this.next_visit.length) {
        this.next_visit.splice(0, this.days)
      } else {
        for (let i = this.next_visit.length; i < this.days; i++) {
          this.next_visit.push('')
        }
      }
    },
    refreshCategory() {
      let self = this;
      axios.get('/api/client/'+self.client.value+'/services?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
          const services = response.data
          self.servicesOptions = services.map((item) => {
          return {
            value: item.service_id,
            label: item.name,
            code: item.case_code_prefix,
            case_count: item.case_count
          }
        });
        self.service = self.servicesOptions[0];
        self.refreshSubcategory();
      })
      .catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    let self = this;
    if (self.$route.params.id) {
      self.showClient = false;
      self.client = {
        value: self.$route.params.id,
        label: '',
      }
      self.refreshCategory();
    }
    axios.get('/api/cases/create?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.statusOptions = response.data.statuses.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        });
        self.billStatusesOptions = response.data.bill_statuses.map((item) => {
          return {
            value: item.id,
            label: item.name
          }
        });
        self.inspection_types = response.data.inspection_types.map((item, index) => {
          return {
            label: item,
            value: index
          }
        });
        self.bill_status = self.billStatusesOptions[0];
        self.roles = response.data.inspectors_roles.map((item) => {
          return {
            value: item.id,
            label: item.role
          }
        });
        self.subcontractorOptions = response.data.subcontractors;
        self.consultantOptions = response.data.consultants;
          self.clientOptions = response.data.clients.map((item) => {
            return {
              value: item.id,
              label: item.company,
            }
          });
      })
      .catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
  }
}


</script>


<style scoped>
.tt2 {
    align-self: center;
    margin-left: 8px;
    color: red;
}

</style>